<mat-dialog-content>
  <div class="acknowledgementHeader">
    {{ 'common.acknowledgementHeader' | translate}}
  </div>

  <hr />

  <div class="acknowledgementTitle">
    {{ 'common.acknowledgementTitle' | translate }}
  </div>

  <div *ngIf="declarationList != null">
    <div class="declaration-container">
      <div *ngFor="let item of declarationList; let i = index">
        <div class="declaration-item">
          <span class="index">{{ i + 1 }}.</span>
          <div class="text" 
              [innerHTML]="item | translate: {
                  insurerName: insurerFullName,
                  productDisclosureSheet: insurerDeclarationDoc?.productDisclosureSheet,
                  dutyOfDisclosure: insurerDeclarationDoc?.dutyOfDisclosure,
                  policyWording: insurerDeclarationDoc?.policyWording,
                  privacyNotice: insurerDeclarationDoc?.privacyNotice
              }">
          </div>
        </div>
      </div>

      <!-- Treatment of Small Amount -->
      <div 
        *ngIf="isShowTreatmentOfSmallAmount"
        class="treatment-of-small-amount"
      >
        <b>{{ treatmentOfSmallAmountTitle | translate }}</b>
        <p>
          {{ treatmentOfSmallAmountDesc | translate }}
        </p>
      </div>
    </div>

    <hr />
  </div>

  <div class="checkbox-container" *ngFor="let item of declarationCheckboxController">
    <label class="checkbox-item">
      <mat-checkbox (change)="onDeclarationCheckboxChange(item)"></mat-checkbox>
      <span [innerHTML]="
        item.acknowledgement | translate: {
          insurerName: insurerFullName,
          productDisclosureSheet: insurerDeclarationDoc?.productDisclosureSheet,
          policyWording: insurerDeclarationDoc?.policyWording,
          privacyNotice: insurerDeclarationDoc?.privacyNotice
        }">
      </span>
    </label>
  </div>

  <button 
    mat-flat-button 
    mat-dialog-close 
    class="back-button"
  >
    {{ "common.back" | translate }}
  </button>

  <button 
    mat-flat-button
    [disabled]="!isAgree"
    [mat-dialog-close]="submit()"
  >
    {{ "plans.readyToPay" | translate }}
  </button>
</mat-dialog-content>